import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
// css
import { DataGrid } from "@mui/x-data-grid";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Link, useNavigate } from "react-router-dom";
import api from "../../../../../utils/apidsf";
import { nanoid } from "nanoid";
import swal from "sweetalert";

import "./PyqTable.css";

export default function PyqTable({ editArticle, forrefresh }) {
  const navigate = useNavigate();
  const [allMcq, setMcq] = useState([]);
  const [refresh, setrefresh] = useState();
  const [selectedQuestions, setSelectedQuestions] = useState([]);

  const fetchMCQ = async () => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const res = await api.get("/admin/pyq/", config);
    const data = res.data.data;
    if (data) {
      const allMockTest = data.map((w, i) => {
        return {
          _id: w._id,
          id: i + 1,
          pyqid: w._id,
          title: w.title,
          subject: w.subject,
          year: w.year,
          exam: w.exam,
          state: w.state || "",
          optionOne: w.optionOne,
          optionTwo: w.optionTwo,
          optionThree: w.optionThree,
          optionFour: w.optionFour,
          rightAnswer: w.rightAnswer,
          year: w?.year,
        };
      });
      console.log(allMockTest);
      setMcq(allMockTest);
    }
  };

  useEffect(() => {
    fetchMCQ();
  }, [forrefresh, refresh]);
  const columns = [
    { field: "id", headerName: "ID", width: 20 },
    { field: "title", headerName: "title", width: 150 },
    { field: "subject", headerName: "subject", width: 80 },
    { field: "exam", headerName: "exam", width: 80 },
    { field: "year", headerName: "year", width: 80 },
    { field: "state", headerName: "state", width: 150 },
    {
      field: "optionOne",
      headerName: "option One",
      sortable: false,
      width: 130,
    },
    {
      field: "optionTwo",
      headerName: "option Two",
      sortable: false,
      width: 130,
    },
    {
      field: "optionThree",
      headerName: "option Three",
      sortable: false,
      width: 250,
    },
    {
      field: "optionFour",
      headerName: "option Four",
      sortable: false,
      width: 250,
    },
    {
      field: "rightAnswer",
      headerName: "right Answer",
      sortable: false,
      width: 50,
    },

    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <>
          <button
            className="edit_article_btn"
            onClick={() => {
              navigate(`/admin/create-pyq/${params?.row?.pyqid}`);
            }}
          >
            Edit
          </button>

          <DeleteOutlinedIcon
            onClick={() => {
              let token = JSON.parse(localStorage.getItem("token"));
              const config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: token,
                },
              };

              swal({
                title: "Are you sure?",
                text:
                  "Once deleted, you will not be able to recover this  file!",
                icon: "warning",
                buttons: true,
              }).then((willDelete) => {
                if (willDelete) {
                  api
                    .delete(`/admin/pyq/${params?.row?.pyqid}`, config)
                    .then((res) => {
                      if (res?.data?.success) {
                        swal({
                          title: "Success!",
                          text: "Pyq Deleted",
                          icon: "success",
                        }).then((value) => {
                          setrefresh(nanoid());
                        });
                      } else {
                        swal({
                          title: "Eroor!",
                          text: "Try Again",
                          icon: "error",
                        });
                      }
                    })
                    .catch((err) => {
                      swal({
                        title: "Eroor!",
                        text: "Try Again",
                        icon: "error",
                      });
                    });
                } else {
                  setrefresh(nanoid());
                }
              });
            }}
            className="admin__userListDelete"
          />
        </>
      ),
    },
  ];

  const handleSelectionChange = (e) => {
    console.log(e);
    setSelectedQuestions(e.map((item) => allMcq[item - 1]._id));
  };

  async function getconfirmation() {
    try {
      const result = await swal({
        title: "Are you sure?",
        text:
          "Once deleted, you will not be able to recover Selected Question!",
        icon: "warning",
        buttons: true,
      });

      if (result) {
        deleteSelectedQuestions();
      }
    } catch (err) {
      console.log({ err });
    }
  }

  const deleteSelectedQuestions = async () => {
    try {
      console.log("delete Selected Questions");
      console.log({ selectedQuestions });
      let token = JSON.parse(localStorage.getItem("token"));
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const response = await api.post(
        "/admin/pyq/deleteMany",
        {
          ids: selectedQuestions,
        },
        config
      );
      console.log(response);

      if (response?.data?.success) {
        window.location.reload();
      }
    } catch (err) {
      console.log({ err });
    }
  };

  return (
    <div
      style={{
        flex: 4,
        padding: 10,
      }}
    >
      {selectedQuestions.length > 0 && (
        <div style={{ margin: 10, width: "100%" }}>
          <button className="edit_article_btn" onClick={getconfirmation}>
            <DeleteOutlinedIcon className="admin__userListDelete" />
          </button>
        </div>
      )}

      <DataGrid
        rows={allMcq}
        columns={columns}
        pageSize={30}
        rowsPerPageOptions={[10]}
        disableSelectionOnClick
        checkboxSelection
        onSelectionModelChange={handleSelectionChange}
      />
    </div>
  );
}
